<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <PageHeader
        title="          Listagem de Alertas
"
        :backroute="{ name: 'home' }"
        backBehavior="route"
      />
    </div>
    <div class="q-mt-md">
      <q-table
        :columns="columns"
        color="primary"
        :rows="listaAlertas"
        :loading="loading"
        table-header-class="bg-accent text-weight-bold"
        flat
        hide-bottom
        class="tabela-tamanho-fixo"
        dense
        :rows-per-page-options="[0]"
        :grid="$q.screen.lt.sm"
        hide-pagination
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Lista de Alertas</span
          >
        </template>
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-8">
                  <span class="q-ml-sm q-mt-sm"
                    ><strong>Alerta: </strong>{{ props.row.notification_id }} -
                    {{ props.row.notification_display }}</span
                  >
                </div>
                <div class="col-2">
                  <div>
                    <q-toggle
                      v-model="props.row.active"
                      @click="
                        verificarEstado(
                          props.row.active,
                          props.row.notification_id
                        )
                      "
                      :disable="disable"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-alerta="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.notification_id }} -
            {{ props.row.notification_display }}
          </q-td>
        </template>
        <template v-slot:body-cell-desativarativar="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <q-toggle
              v-model="props.row.active"
              @click="
                verificarEstado(props.row.active, props.row.notification_id)
              "
              :disable="disable"
            />
          </q-td>
        </template>
      </q-table>
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import PageHeader from "../../../components/PageHeader.vue";
const columns = [
  {
    name: "alerta",
    label: "Alertas",
    align: "left",
  },
  {
    name: "desativarativar",
    label: "Desativar/Ativar",
    align: "left",
  },
];
export default {
  components: { PageHeader },
  setup() {
    const store = useStore();

    const listaAlertas = ref([]);
    let loading = ref(false);
    let disable = ref(false);

    const listarAlertas = async () => {
      loading.value = true;
      const response = await store.dispatch("configuracao/listarAlertas");

      listaAlertas.value = response.data.results;

      loading.value = false;
    };

    const verificarEstado = async (estado, id) => {
      if (estado) {
        desativarAtivarAlerta(id, "optin", false);
      } else {
        desativarAtivarAlerta(id, "optout", true);
      }
    };

    const desativarAtivarAlerta = async (notification_id, action, optin) => {
      disable.value = true;
      try {
        await store.dispatch("configuracao/desativarAtivarAlerta", {
          notification_id: notification_id,
          action: action,
          optin: optin,
        });
        disable.value = false;
        listarAlertas();
      } catch (error) {
        console.log(error);
        disable.value = false;
      }
    };

    onMounted(listarAlertas);
    return {
      listarAlertas,
      columns,
      listaAlertas,
      loading,
      verificarEstado,
      desativarAtivarAlerta,
      disable,
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 14px;
  }
  .cursor {
    margin-top: 13px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
}
</style>
